<div class="vincent_advantages vincent_advantages1 vincent_corners_bottom">
    <div data-parallax='{"y":"45vh","scale":1,"rotate":0,"opacity":1}' class="vincent_parallax_background"></div>
        <div class="vincent_container">
            <div class="row gutters">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="vincent_advantages_item vincent_icon_box">
                        <img src="assets/imgs/icon_1.png" alt="">
                        <h4>{{"Quality_foods" | translate}}</h4>
                        <p>{{"food_quilety_text" | translate}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="vincent_advantages_item vincent_icon_box">
                        <img src="assets/imgs/icon_3.png" alt="">
                        <h4>{{"Fastest_delivery" | translate}}</h4>
                        <p>{{"Fastest_delivery_text" | translate}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="vincent_advantages_item vincent_icon_box">
                        <img src="assets/imgs/icon_2.png" alt="">
                        <h4>{{"Original_recipes" | translate}}</h4>
                        <p>{{"Original_recipes_text" | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
</div> 
